import React, { useState, useRef, useEffect } from 'react';
import {
  KTSVG,
  SimpleAlert,
  maskPhoneNumber,
  cleanPhoneNumber,
  toAbsoluteUrl,
} from '../../../../_mexablock/helpers';
import { NumericFormat } from 'react-number-format';
import { Modal } from 'react-bootstrap-v5';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { updDistribuidor } from '../../../service/distribuidores/Distribuidores';
import { TipoDistribuidorModel } from '../models/DistribuidorModel';
import {
  useSelectGeneric,
  useSelectTypePerson,
} from '../../catalogos/generico/hooks/genericoHook';

type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  infoDis: any;
};

const DistribuidorSchema = Yup.object().shape({
  type_contributor_id: Yup.number().min(1, 'Requerido.'),
  type_commission_id: Yup.number().min(1, 'Requerido.'),
  street: Yup.string().max(30, 'Máximo 30 caracteres'),
  city: Yup.string().max(50, 'Máximo 50 caracteres'),
  state: Yup.string().max(50, 'Máximo 50 caracteres'),
  postal_code: Yup.string().max(5, 'Requerido.'),
  name: Yup.string().max(100, 'Máximo 100 caracteres'),
  business_name: Yup.string().max(100, 'Máximo 100 caracteres'),
  email: Yup.string()
    .email('Formato de correo inválido.')
    .min(3, 'Mínimo 3 caracteres.')
    .max(50, 'Máximo 50 caracteres.'),
  billing_mail: Yup.string()
    .email('Formato de correo inválido.')
    .min(3, 'Mínimo 3 caracteres.')
    .max(50, 'Máximo 50 caracteres.'),

  cfdi_id: Yup.number().required('Requerido.').min(1, 'Requerido.'),
  // pdfFile: Yup.mixed()
  //   .required('Requerido.')
  //   .test('is-pdf', 'El archivo debe ser un PDF', (value) => {
  //     if (value) {
  //       return value.type === 'application/pdf';
  //     }
  //     return false;
  //   }),
  rfc: Yup.string().matches(
    /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/,
    'Formato de RFC inválido'
  ),
  interbank_key: Yup.string().min(18, 'Mínimo 18 caracteres'),
  first_name: Yup.string().max(30, 'Máximo 30 caracteres'),
  mother_last_name: Yup.string().max(30, 'Máximo 30 caracteres'),
  father_last_name: Yup.string().max(30, 'Máximo 30 caracteres'),
  birthdate: Yup.date(),
  phone: Yup.string().min(10, 'Formato inválido'),
  gender_id: Yup.number().min(1, 'Requerido.'),
  account_owner_first_name: Yup.string().max(30, 'Máximo 30 caracteres'),
  account_owner_last_name: Yup.string().max(30, 'Máximo 30 caracteres'),
});

const currentDate = new Date();
const fechaMaxima = new Date(currentDate);
fechaMaxima.setFullYear(currentDate.getFullYear() - 18);
const maxDate = fechaMaxima.toISOString().split('T')[0];

const UpdateModal: React.FC<Props> = ({ infoDis, show, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const constancyRef = useRef<HTMLInputElement>(null);
  const [documentName, setDocumentName] = useState<string>('');
  const { catalog: genders } = useSelectGeneric('GEN');
  const { catalog: cfdi } = useSelectGeneric('CFDI');
  const { catalog: tipo_comision } = useSelectGeneric('TDC');
  const { catalogTypePerson: tipo_persona } = useSelectTypePerson();
  const [changeTypeContributor, setChangeTypeContributor] = useState<Number>(0);
  const [disInactivo, setDisInactivo] = useState<boolean>(false);
  const [initValuesDis, setInitValuesDis] = useState<TipoDistribuidorModel>({
    type_contributor_id: 0,
    type_commission_id: 0,
    commission_percent: '',
    name: '',
    business_name: '',
    street: '',
    city: '',
    state: '',
    postal_code: 0,
    first_name: '',
    father_last_name: '',
    mother_last_name: '',
    gender_id: 0,
    birthdate: '',
    email: '',
    phone: '',
    interbank_key: '',
    bank_name: '',
    account_owner_first_name: '',
    account_owner_last_name: '',
    cfdi_id: 0,
    billing_mail: '',
    rfc: '',
    pdfFile: '',
    id: 0,
  });

  const formDistribuidor = useFormik({
    initialValues: initValuesDis,
    validationSchema: DistribuidorSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting, setFieldError }) => {
      let idDistribuidor = Number(values.id);
      setLoading(true);
      setTimeout(() => {
        updDistribuidor(values, idDistribuidor)
          .then((res) => {
            const {
              data: { message },
            } = res;
            SimpleAlert(message, 3000, 'success');
            formDistribuidor.resetForm();
            setDocumentName('');
            setLoading(false);
            setChangeTypeContributor(0);
            handleClose(true);
          })
          .catch((err) => {
            let resMessageToast: string = '';
            const {
              data: { message, details = null },
            } = err.response;
            resMessageToast = `${message}`;
            if (details.length) {
              setStatus(`${details[0]?.message}`);
            }
            setLoading(false);
            setSubmitting(false);
            SimpleAlert(resMessageToast, 3000, 'error');
          });
      }, 1000);
    },
  });

  const handlePhoneChange = (values: any) => {
    const value = values.target.value.toString();
    const maskedPhoneNumber = maskPhoneNumber(value);
    formDistribuidor.setFieldValue('phone', maskedPhoneNumber);
    formDistribuidor.setFieldValue(
      'phone',
      cleanPhoneNumber(maskedPhoneNumber)
    );
  };

  const onOpenFile = () => {
    constancyRef?.current?.click();
  };

  const handleChangeInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const value = event.target.value;
    const valueReg = value.replace(/\d/g, '');
    const cleanInput = valueReg.replace(/^\s+|\s+(?=\s)/g, '');
    const inputLimpio = cleanInput.replace(/[^\wáéíóúüÁÉÍÓÚÜñÑ\s]/g, '');
    formDistribuidor.setFieldValue(key, inputLimpio);
  };

  const handleChangeInputNumeric = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const value = event.target.value;
    const cleanInput = value.replace(/[^\w\dáéíóúüÁÉÍÓÚÜñÑ]/g, '');
    formDistribuidor.setFieldValue(key, cleanInput);
  };

  const changeUtilityValue = (values: any) => {
    const { floatValue } = values;
    let utilidad_porcentaje = floatValue || 0;
    formDistribuidor.setFieldValue('commission_percent', utilidad_porcentaje);
  };

  useEffect(() => {
    setInitValuesDis({
      type_contributor_id: infoDis?.id_type_person ?? 0,
      type_commission_id: infoDis?.account?.type_commision_id ?? 0,
      commission_percent: infoDis?.account?.commission_percent ?? 0,
      name: infoDis?.name ?? '',
      business_name: infoDis?.business_name ?? '',
      street: infoDis?.street ?? '',
      city: infoDis?.city ?? '',
      state: infoDis?.state ?? '',
      postal_code: infoDis?.postal_code ?? '',
      first_name: infoDis?.user?.first_name ?? '',
      father_last_name: infoDis?.user?.father_last_name ?? '',
      mother_last_name: infoDis?.user?.mother_last_name ?? '',
      gender_id: infoDis?.user?.gender_id ?? 0,
      birthdate: infoDis?.user?.birthdate ?? '',
      email: infoDis?.user?.email ?? '',
      phone: infoDis?.phone ?? '',
      interbank_key: '',
      bank_name: infoDis?.bank_name ?? '',
      account_owner_first_name: infoDis?.first_name ?? '',
      account_owner_last_name: infoDis?.father_last_name ?? '',
      cfdi_id: infoDis?.cfdi_id ?? 0,
      billing_mail: infoDis?.email ?? '',
      rfc: infoDis?.rfc ?? '',
      pdfFile: '',
      id: infoDis?.id ?? 0,
    });
    setDocumentName(infoDis?.constancy);
    setChangeTypeContributor(infoDis?.id_type_person);
    setDisInactivo(infoDis?.active ? false : true);
  }, [infoDis, show]);

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered modal-xl"
      show={show}
      onHide={() => {
        setDocumentName('');
        setChangeTypeContributor(0);
        formDistribuidor.resetForm();
        handleClose(false);
      }}
    >
      <div className="modal-content">
        <div className="modal-header pb-0 border-0 justify-content-end">
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            data-bs-dismiss="modal"
            onClick={() => {
              setDocumentName('');
              setChangeTypeContributor(0);
              formDistribuidor.resetForm();
              handleClose(false);
            }}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>

        <div className="modal-body scroll-y mx-5 pt-0">
          <div className="text-center mb-13">
            <h1 className="mb-3">Editar distribuidor</h1>
            <div className="text-muted fw-semibold fs-5">
              Modifica información del distribuidor
            </div>
          </div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formDistribuidor.handleSubmit}
          >
            <div className="row g-9 mb-5">
              <div className="col-md-3">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Tipo de contribuyente
                  </label>
                  {formDistribuidor.touched.type_contributor_id &&
                    formDistribuidor.errors.type_contributor_id && (
                      <div className="fv-plugins-message-container text-danger w-auto">
                        <span role="alert">
                          {formDistribuidor.errors.type_contributor_id}
                        </span>
                      </div>
                    )}
                </div>
                <select
                  disabled
                  className="form-select"
                  value={formDistribuidor.values.type_contributor_id}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    formDistribuidor.setFieldValue(
                      'type_contributor_id',
                      value
                    );
                    setChangeTypeContributor(value);
                  }}
                >
                  <option value={0}>Seleccione</option>
                  {tipo_persona.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {changeTypeContributor === 1 && (
                <>
                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Comisión
                      </label>
                      {formDistribuidor.touched.type_commission_id &&
                        formDistribuidor.errors.type_commission_id && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.type_commission_id}
                            </span>
                          </div>
                        )}
                    </div>
                    <select
                      disabled
                      className="form-select"
                      {...formDistribuidor.getFieldProps('type_commission_id')}
                    >
                      <option value={0}>Seleccione</option>
                      {tipo_comision.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-40">
                        Porcentaje de comisión
                      </label>
                      {formDistribuidor.touched.commission_percent &&
                        formDistribuidor.errors.commission_percent && (
                          <div className="fv-plugins-message-container text-danger w-60 ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.commission_percent}
                            </span>
                          </div>
                        )}
                    </div>
                    <NumericFormat
                      disabled
                      type="text"
                      name="commission_percent"
                      className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                      value={formDistribuidor.values.commission_percent}
                      decimalScale={0}
                      allowLeadingZeros
                      fixedDecimalScale
                      placeholder="Porcentaje de comisión"
                      suffix={' %'}
                      thousandSeparator={''}
                      allowNegative={false}
                      isAllowed={(values: any) => {
                        const { floatValue } = values;
                        let allow =
                          floatValue <= 100 || floatValue === undefined;
                        return allow;
                      }}
                      onValueChange={changeUtilityValue}
                    />
                  </div>
                </>
              )}
              {changeTypeContributor === 2 && (
                <>
                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <div className="w-100 d-flex">
                      <label className={`fw-bold fs-6 mb-2 w-auto required`}>
                        Nombre de la empresa
                      </label>
                      {formDistribuidor.touched.name &&
                        formDistribuidor.errors.name && (
                          <div className="fv-plugins-message-container text-danger w-100 ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.name}
                            </span>
                          </div>
                        )}
                    </div>
                    <input
                      disabled={disInactivo}
                      placeholder="Nombre del distribuidor"
                      {...formDistribuidor.getFieldProps('name')}
                      className="form-control"
                      type="text"
                      name="name"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                          ![
                            'Backspace',
                            'Tab',
                            'ArrowLeft',
                            'ArrowRight',
                            'Delete',
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Razón social
                      </label>
                      {formDistribuidor.touched.business_name &&
                        formDistribuidor.errors.business_name && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.business_name}
                            </span>
                          </div>
                        )}
                    </div>
                    <input
                      disabled={disInactivo}
                      placeholder="Razón social"
                      {...formDistribuidor.getFieldProps('business_name')}
                      className="form-control"
                      type="text"
                      name="business_name"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                          ![
                            'Backspace',
                            'Tab',
                            'ArrowLeft',
                            'ArrowRight',
                            'Delete',
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Comisión
                      </label>
                      {formDistribuidor.touched.type_commission_id &&
                        formDistribuidor.errors.type_commission_id && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.type_commission_id}
                            </span>
                          </div>
                        )}
                    </div>
                    <select
                      disabled
                      className="form-select"
                      {...formDistribuidor.getFieldProps('type_commission_id')}
                    >
                      <option value={0}>Seleccione</option>
                      {tipo_comision.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Calle y Número
                      </label>
                      {formDistribuidor.touched.street &&
                        formDistribuidor.errors.street && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.street}
                            </span>
                          </div>
                        )}
                    </div>
                    <input
                      disabled={disInactivo}
                      placeholder="Calle y Número"
                      {...formDistribuidor.getFieldProps('street')}
                      className="form-control"
                      type="text"
                      name="street"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-ZñÑáéíóúÁÉÍÓÚüÜ0-9 ]$/.test(e.key) &&
                          ![
                            'Backspace',
                            'Tab',
                            'ArrowLeft',
                            'ArrowRight',
                            'Delete',
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Ciudad
                      </label>
                      {formDistribuidor.touched.city &&
                        formDistribuidor.errors.city && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.city}
                            </span>
                          </div>
                        )}
                    </div>
                    <input
                      disabled={disInactivo}
                      placeholder="Ciudad"
                      {...formDistribuidor.getFieldProps('city')}
                      className="form-control"
                      type="text"
                      name="city"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                          ![
                            'Backspace',
                            'Tab',
                            'ArrowLeft',
                            'ArrowRight',
                            'Delete',
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-3">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-auto">
                        Estado
                      </label>
                      {formDistribuidor.touched.state &&
                        formDistribuidor.errors.state && (
                          <div className="fv-plugins-message-container text-danger w-auto ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.state}
                            </span>
                          </div>
                        )}
                    </div>
                    <input
                      disabled={disInactivo}
                      placeholder="Estado"
                      {...formDistribuidor.getFieldProps('state')}
                      className="form-control"
                      type="text"
                      name="state"
                      autoComplete="off"
                      onKeyDown={(e) => {
                        if (
                          !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                          ![
                            'Backspace',
                            'Tab',
                            'ArrowLeft',
                            'ArrowRight',
                            'Delete',
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>

                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-40">
                        Porcentaje de comisión
                      </label>
                      {formDistribuidor.touched.commission_percent &&
                        formDistribuidor.errors.commission_percent && (
                          <div className="fv-plugins-message-container text-danger w-60 ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.commission_percent}
                            </span>
                          </div>
                        )}
                    </div>
                    <NumericFormat
                      disabled
                      type="text"
                      name="commission_percent"
                      className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                      value={formDistribuidor.values.commission_percent}
                      decimalScale={0}
                      allowLeadingZeros
                      fixedDecimalScale
                      placeholder="Porcentaje de comisión"
                      suffix={' %'}
                      thousandSeparator={''}
                      allowNegative={false}
                      isAllowed={(values: any) => {
                        const { floatValue } = values;
                        let allow =
                          floatValue <= 100 || floatValue === undefined;
                        return allow;
                      }}
                      onValueChange={changeUtilityValue}
                    />
                  </div>
                  <div className="col-md-3 fv-row fv-plugins-icon-container">
                    <div className="w-100 d-flex">
                      <label className="required fw-bold fs-6 mb-2 w-40">
                        Código postal
                      </label>
                      {formDistribuidor.touched.postal_code &&
                        formDistribuidor.errors.postal_code && (
                          <div className="fv-plugins-message-container text-danger w-60 ms-5">
                            <span role="alert">
                              {formDistribuidor.errors.postal_code}
                            </span>
                          </div>
                        )}
                    </div>
                    <NumericFormat
                      disabled={disInactivo}
                      name="postal_code"
                      className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                      value={formDistribuidor.values.postal_code}
                      decimalScale={0}
                      allowLeadingZeros
                      maxLength={5}
                      minLength={5}
                      fixedDecimalScale
                      placeholder="Código postal"
                      prefix=""
                      thousandSeparator=""
                      pattern="[0-9]*"
                      onValueChange={(values) => {
                        const { value } = values;
                        formDistribuidor.setFieldValue(
                          'postal_code',
                          value ? value : ''
                        );
                      }}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="text-gray-700 mt-7 fs-4 fw-bold">
              Datos del encargado
            </div>
            <div className="separator my-5"></div>
            <div className="row g-9 mb-5">
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Nombre
                  </label>
                  {formDistribuidor.touched.first_name &&
                    formDistribuidor.errors.first_name && (
                      <div className="fv-plugins-message-container text-danger w-100 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.first_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Nombre del encargado"
                  {...formDistribuidor.getFieldProps('first_name')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="first_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'first_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-40">
                    Apellido Paterno
                  </label>
                  {formDistribuidor.touched.father_last_name &&
                    formDistribuidor.errors.father_last_name && (
                      <div className="fv-plugins-message-container text-danger w-50 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.father_last_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Apellido Paterno"
                  {...formDistribuidor.getFieldProps('father_last_name')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="user.father_last_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'father_last_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-40">
                    Apellido Materno
                  </label>
                  {formDistribuidor.touched.mother_last_name &&
                    formDistribuidor.errors.mother_last_name && (
                      <div className="fv-plugins-message-container text-danger w-60 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.mother_last_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Apellido Materno"
                  {...formDistribuidor.getFieldProps('mother_last_name')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="mother_last_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'mother_last_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
            <div className="row g-9 mb-5">
              <div className="col-md-3 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Género
                  </label>
                  {formDistribuidor.touched.gender_id &&
                    formDistribuidor.errors.gender_id && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.gender_id}
                        </span>
                      </div>
                    )}
                </div>
                <select
                  disabled={disInactivo}
                  className="form-select"
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-allow-clear="true"
                  {...formDistribuidor.getFieldProps('gender_id')}
                >
                  <option value={0}>Seleccione</option>
                  {genders.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Fecha de nacimiento
                  </label>
                  {formDistribuidor.touched.birthdate &&
                    formDistribuidor.errors.birthdate && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.birthdate}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  type="date"
                  className="form-control"
                  value={
                    formDistribuidor.values.birthdate
                      ? formDistribuidor.values.birthdate.split('T')[0]
                      : ''
                  }
                  max={maxDate}
                  onChange={(e) => {
                    if (e.target.value) {
                      formDistribuidor.setFieldValue(
                        'birthdate',
                        e.target.value
                      );
                    }
                  }}
                ></input>
              </div>
              <div className="col-md-3 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Correo
                  </label>
                  {formDistribuidor.touched.email &&
                    formDistribuidor.errors.email && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.email}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Correo"
                  {...formDistribuidor.getFieldProps('email')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="email"
                  autoComplete="off"
                />
              </div>
              <div className="col-md-3 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Teléfono
                  </label>
                  {formDistribuidor.touched.phone &&
                    formDistribuidor.errors.phone && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.phone}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  className="form-control mb-3"
                  value={formDistribuidor.values.phone}
                  placeholder="Teléfono"
                  prefix=""
                  onChange={handlePhoneChange}
                />
              </div>
            </div>

            <div className="row g-9 mb-5"></div>
            <div className="text-gray-700 mt-7 fs-4 fw-bold">
              Datos bancarios
            </div>
            <div className="separator my-5"></div>
            <div className="row g-9 mb-5">
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Nombre
                  </label>
                  {formDistribuidor.touched.account_owner_first_name &&
                    formDistribuidor.errors.account_owner_first_name && (
                      <div className="fv-plugins-message-container text-danger w-100 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.account_owner_first_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Propietario de la cuenta"
                  {...formDistribuidor.getFieldProps(
                    'account_owner_first_name'
                  )}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="account_owner_first_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'account_owner_first_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-40">
                    Apellido Paterno
                  </label>
                  {formDistribuidor.touched.account_owner_last_name &&
                    formDistribuidor.errors.account_owner_last_name && (
                      <div className="fv-plugins-message-container text-danger w-50 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.account_owner_last_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Propietario de la cuenta"
                  {...formDistribuidor.getFieldProps('account_owner_last_name')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="account_owner_last_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'account_owner_last_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>

              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-40">
                    CLABE Interbancaria
                  </label>
                  {formDistribuidor.touched.interbank_key &&
                    formDistribuidor.errors.interbank_key && (
                      <div className="fv-plugins-message-container text-danger w-60 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.interbank_key}
                        </span>
                      </div>
                    )}
                </div>
                <NumericFormat
                  disabled={disInactivo}
                  name="clabe"
                  className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                  value={formDistribuidor.values.interbank_key}
                  decimalScale={0}
                  allowLeadingZeros
                  maxLength={18}
                  fixedDecimalScale
                  placeholder="******************"
                  prefix=""
                  thousandSeparator=""
                  onValueChange={(values) => {
                    const { value } = values;
                    formDistribuidor.setFieldValue(
                      'interbank_key',
                      value ? value : ''
                    );
                  }}
                />
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className=" fw-bold fs-6 mb-2 w-auto required">
                    Banco
                  </label>
                  {formDistribuidor.touched.bank_name &&
                    formDistribuidor.errors.bank_name && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.bank_name}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Banco"
                  {...formDistribuidor.getFieldProps('bank_name')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="bank_name"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'bank_name');
                  }}
                  onKeyDown={(e) => {
                    if (
                      !/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/.test(e.key) &&
                      ![
                        'Backspace',
                        'Tab',
                        'ArrowLeft',
                        'ArrowRight',
                        'Delete',
                      ].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>

            <div className="text-gray-700 mt-7 fs-4 fw-bold">
              Datos de facturación
            </div>
            <div className="separator my-5"></div>
            <div className="row g-9 mb-5">
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-auto">
                    Uso de CFDI
                  </label>
                  {formDistribuidor.touched.cfdi_id &&
                    formDistribuidor.errors.cfdi_id && (
                      <div className="fv-plugins-message-container text-danger w-auto ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.cfdi_id}
                        </span>
                      </div>
                    )}
                </div>
                <select
                  disabled={disInactivo}
                  className="form-select"
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-allow-clear="true"
                  {...formDistribuidor.getFieldProps('cfdi_id')}
                >
                  <option value={0}>Seleccione</option>
                  {cfdi.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className="required fw-bold fs-6 mb-2 w-40">
                    Correo
                  </label>
                  {formDistribuidor.touched.billing_mail &&
                    formDistribuidor.errors.billing_mail && (
                      <div className="fv-plugins-message-container text-danger w-60 ms-5">
                        <span role="alert">
                          {formDistribuidor.errors.billing_mail}
                        </span>
                      </div>
                    )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="Correo"
                  {...formDistribuidor.getFieldProps('billing_mail')}
                  className="form-control mb-3 mb-lg-0"
                  type="text"
                  name="billing_mail"
                  autoComplete="off"
                />
              </div>
              <div className="col-md-4 fv-row fv-plugins-icon-container">
                <div className="w-100 d-flex">
                  <label className=" fw-bold fs-6 mb-2 w-auto required">
                    RFC
                  </label>
                  {formDistribuidor.touched.rfc && formDistribuidor.errors.rfc && (
                    <div className="fv-plugins-message-container text-danger w-auto ms-5">
                      <span role="alert">{formDistribuidor.errors.rfc}</span>
                    </div>
                  )}
                </div>
                <input
                  disabled={disInactivo}
                  placeholder="RFC"
                  {...formDistribuidor.getFieldProps('rfc')}
                  className="form-control mb-3 mb-lg-0"
                  maxLength={13}
                  type="text"
                  name="rfc"
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInputNumeric(e, 'rfc');
                  }}
                />
              </div>
            </div>

            <div className="row g-9 justify-content-center text-center">
              <div className="col-md-6 fv-row fv-plugins-icon-container">
                <div className="d-flex justify-content-center text-center p-2">
                  <a
                    href="#/"
                    className="text-gray-800 text-hover-primary d-flex flex-column"
                  >
                    <div className="symbol symbol-50px mb-6">
                      <img
                        src={
                          formDistribuidor.values.pdfFile
                            ? toAbsoluteUrl('/media/svg/files/pdf.svg')
                            : toAbsoluteUrl('/media/svg/files/upload.svg')
                        }
                        className="image-input-wrapper"
                        onClick={onOpenFile}
                        crossOrigin="anonymous"
                        alt="INE"
                      />
                    </div>

                    <div className="d-flex">
                      <div
                        className="required fs-5 mb-2 flex-column"
                        onClick={onOpenFile}
                      >
                        Constancia de situación fiscal
                      </div>
                      <div className="fs-5 mb-2 flex-column ms-5">
                        {formDistribuidor.touched.pdfFile &&
                          formDistribuidor.errors.pdfFile && (
                            <div className="fv-plugins-message-container text-danger w-100">
                              <span role="alert">
                                {formDistribuidor.errors.pdfFile}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                    <label className="min-h-30px text-success">
                      {documentName}
                    </label>

                    <input
                      disabled={disInactivo}
                      style={{ display: 'none' }}
                      ref={constancyRef}
                      type="file"
                      name="constancy"
                      accept=".pdf"
                      onChange={(event) => {
                        if (event.currentTarget.files) {
                          let files = event.currentTarget.files;
                          if (files.length > 0) {
                            formDistribuidor.setFieldValue('pdfFile', files[0]);
                            setDocumentName(files[0].name);
                          }
                        }
                      }}
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="text-center pt-10">
              <button
                type="reset"
                className="btn btn-light me-3"
                data-kt-users-modal-action="cancel"
                onClick={() => {
                  setDocumentName('');
                  formDistribuidor.resetForm();
                  handleClose(false);
                }}
              >
                Cancelar
              </button>
              {!disInactivo ? (
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-kt-users-modal-action="submit"
                  disabled={loading}
                >
                  {!loading && <span className="indicator-label">Guardar</span>}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: 'block' }}
                    >
                      Espere por favor...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};
export { UpdateModal };
